import React from "react";
// import "./../../App.css";

const Chat = () => {
  return (
    <>
      <h1 className="text-primary fw-bold d-flex justify-content-center">
        {" "}
        <i className="bi bi-border-width text-primary me-2"></i>ติดตามงาน
      </h1>
      <div className="row d-flex justify-content-center">
        <div className="mb-2 col-lg-12 ">
          <label htmlFor="exampleFormControlInput1" className="form-label fs-5">
            <i className="bi bi-book-half text-info me-2"></i> หัวข้องาน
          </label>
          <input
            type="text"
            className="form-control"
            id="exampleFormControlInput1"
          />
        </div>
        <div className="mb-2 col-lg-12">
          <label
            htmlFor="exampleFormControlTextarea1"
            className="form-label fs-5"
          >
            <i className="bi bi-border-width text-info me-2"></i>
            อธิบายเพิ่มเติม
          </label>
          <textarea
            className="form-control"
            id="exampleFormControlTextarea1"
            rows={3}
            placeholder="เพิ่มคำอธิบายโดยละเอียด"
          />
        </div>
      </div>
      <div className="mb-3">
        <input
          type="text"
          className="form-control input-default "
          placeholder="input-default"
        />
      </div>
      <div className="  col-lg-6 ">
        <div className="row ">
          <div className="col-auto mt-4">
            <img
              className="rounded-circle mr-1"
              src="https://api-idms.advanceagro.net/hrms/employee/542484/photocard/?size=70"
              data-toggle="tooltip"
              data-placement="bottom"
              title
              style={{
                width: "100%",
                maxHeight: 30,
                maxWidth: 30,
                border: "none",
              }}
            />
          </div>
          <div className="col-lg-11">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label fs-5"
            ></label>
            <input
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="แสดงความคิดเห็น"
            />
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="card1 shadow contact-bx my-3 ">
          <div className="card-body user-profile">
            <i className="bi bi-home" style={{ fontSize: "60px" }} />

            <div className="row">
              <div className="col-lg-6 d-flex justify-content-start">
                <img
                  className="rounded-circle mr-1"
                  src="https://api-idms.advanceagro.net/hrms/employee/542484/photocard/?size=70"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title
                  style={{
                    width: "100%",
                    maxHeight: 50,
                    maxWidth: 50,
                    border: "none",
                  }}
                />
                <span className="text-primary user-name ms-3 ">
                  วิรุต บุตรชัยภูมิ
                </span>
                <span className="user-name ms-3 ">ได้ทำการอัพเดทรูปภาพ</span>
              </div>

              <div className="col-lg-6">
                <span className="text-black user-name "></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container-custom mb-4">
        <div className="container darkerstart m-2">
          <img
            src="https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=15229&size=320"
            alt="Avatar"
          />
          <p>ติดตามงานค่ะ</p>
          <span className="time-right">11:00</span>
        </div>
        <div className="container darker m-2">
          <img
            src="https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=18492872&size=320"
            alt="Avatar"
            className="right"
          />
          <p>กำลังทำครับ</p>
          <span className="time-left">11:01</span>
        </div>
        <div className="container  darkerstart m-2">
          <img
            src="https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=630002&size=320"
            alt="Avatar"
          />
          <p>จะเสร็จประมาณช่วงไหนครับ</p>
          <span className="time-right">11:02</span>
        </div>
        <div className="container darker m-2">
          <img
            src="https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=18492872&size=320"
            alt="Avatar"
            className="right"
          />
          <p>อีก 2 ปีครับ</p>
          
          <span className="time-left">11:05</span>
        </div>
      </div> */}
      <div></div>
    </>
  );
};

export default Chat;
